// This is a horrible hack to swap the order of the labels in a legend. I didn't
// want to rewrite rechart's legend component, which already handles all of the
// graph types with nice icons and everything - I just wanted to use what they
// have and reverse the order of the labels. You can also do this by reversing
// the order that you declare the data in the chart, but that will put the
// second data type behind the first, and you might not want that.
import { expected } from '@aloft/toolkit-shared';

import { Legend } from 'recharts';
import { Props } from 'recharts/types/component/Legend';

export const ReversedLegend = (props: Props) => {
  // we're just assigning content here as a way of pulling it out of props so
  // we don't get into a rendering loop
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { content, payload, ...rest } = props;

  return (
    <Legend
      {...rest}
      payload={expected(payload).slice().reverse()}
      // these are to make typescript happy. we seem to be ok with passing
      // null for the ref for what we are doing.
      ref={null}
      height={30}
      width={Number(rest.width)}
    />
  );
};
